import styled from 'styled-components'

export const Container = styled.div`
  margin: 2em 0 1em 0;
`
